<template>
  <div class="color">
    <documentation-container :title="title">
      <template slot="content">
        <div class="content-doc">
          <div class="content-doc-wrapper">
            <div class="item" v-for="(color, index) in colors" :key="index">
              <div class="circle" :style="{ background: color.code }"></div>
              <div class="description">
                <p class="font-regular">
                  #{{color.name}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import DocumentationContainer from '@/components/DocumentationContainer'

export default {
  name: 'adx-color',
  components: {
    'documentation-container': DocumentationContainer
  },
  data(){
    return {
      title: 'Color Palette',
      colors: [
        {
          name: 'black',
          code: '#262626',
        },
        {
          name: 'warm-grey',
          code: '#999999'
        },
        {
          name: 'orange-red',
          code: '#FF3B30'
        },
        {
          name: 'bright-blue',
          code: '#007AFF'
        },
        {
          name: 'sunrise',
          code: '#FF9500'
        },
        {
          name: 'sunflower-yellow',
          code: '#FFCC00'
        },
        {
          name: 'lightish-green',
          code: '#4CD964'
        },
        {
          name: 'sky-blue',
          code: '#5AC8FA'
        },
        {
          name: 'dark-periwinkle',
          code: '#5856D6'
        },
        {
          name: 'pale-grey',
          code: '#E5E5EA'
        },
        {
          name: 'snow',
          code: '#FAFAFA'
        },
        {
          name: 'reddish-pink',
          code: '#FF2D55'
        },
        {
          name: 'blue-teal',
          code: '#4ebbec'
        },
        {
          name: 'green',
          code: '#3aaf4e'
        },
        {
          name: 'white',
          code: '#FFFFFF'
        }
      ]
    }
  }

}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>